import { forwardRef, type ImgHTMLAttributes } from "react";
import { cx } from "@/utils/cx";

interface ImageProps extends ImgHTMLAttributes<HTMLImageElement> {
	src: string;
	alt: string;
	width?: number;
	height?: number;
	fill?: boolean;
	priority?: boolean;
	className?: string;
}

export const Image = forwardRef<HTMLImageElement, ImageProps>(
	(
		{ src, alt, width, height, fill, priority, className, style, ...props },
		ref
	) => {
		const imageStyle: React.CSSProperties = {
			...style,
			...(fill && {
				position: "absolute",
				inset: 0,
				width: "100%",
				height: "100%",
				objectFit: "cover",
			}),
		};

		return (
			<img
				alt={alt}
				className={cx(className)}
				height={height}
				loading={priority ? "eager" : "lazy"}
				ref={ref}
				src={src}
				style={imageStyle}
				width={width}
				{...props}
			/>
		);
	}
);

Image.displayName = "Image";
